import * as React from 'react';
import {CSSProperties, MouseEventHandler} from 'react';
import styled from 'styled-components';
import {Actions} from '../types/Action';
import {Field} from '../types/Field';
import {ResourceDetails} from '../types/ResourceDetails';
import {Schema} from '../types/Schema';
import {widgetProps} from '../widgets/common';
import {rowPadding} from './ResourceDetailsTable';
import {useOnPressAction} from '../fields/hooks/useOnPressAction';

type TextAlign = 'left' | 'right' | 'center';

export type OnClickFn = MouseEventHandler<HTMLElement>;

export type ActionTextProps = {
  onClick?: OnClickFn;
  style: CSSProperties;
};

export function ActionText(props: {
  value: any;
  field: Field;
  schema: Schema;
  item: ResourceDetails;
  actions: Actions;
  style: CSSProperties;
}): JSX.Element {
  const onClick = useOnPressAction(
    props.field,
    props.schema,
    props.item,
    props.actions,
  );

  const textAlign = widgetProps<TextAlign>(props.field, 'text_align', 'left');
  const justifyContent = selectJustifyContent(textAlign);

  const fill = widgetProps<boolean>(props.field, 'fill', false);
  const fillStyle = fill ? {margin: '-' + rowPadding, padding: rowPadding} : {};

  const Elem = !onClick ? Text : ActionableText;

  return (
    <Elem
      title={props.value}
      style={{...props.style, justifyContent, ...fillStyle}}
      onClick={onClick}>
      {props.value}
    </Elem>
  );
}

function selectJustifyContent(textAlign: TextAlign): string {
  switch (textAlign) {
    case 'left':
      return 'flex-start';
    case 'center':
      return 'center';
    case 'right':
      return 'flex-end';
  }
}

const Text = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 1.5;
  display: flex;
  align-items: center;
`;

const ActionableText = styled(Text)`
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;
